// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import './uploadImg';
import Toast from './toast';
import './feedbacks';
import './home';
import './topics';
import './bi';
import './regions-selector';
import './languages-selector';
import './current-user-text';

import TurbolinksPrefetch from 'turbolinks-prefetch';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();

TurbolinksPrefetch.start();

const ClipboardJS = require('clipboard');

document.addEventListener('turbolinks:load', () => {
  const clipboard = new ClipboardJS('.clipboard-button');
  const lbToast = new Toast();
  clipboard.on('success', (_) => {
    lbToast.toast('微信号已复制成功，跳转微信中…', 1000);
    setTimeout(() => {
      window.open('weixin://');
    }, 1000);
  });
});
